import axios from "store/axios-broker";
import * as types from "store/types.js";
import { show as notifySuccess } from "store/actions/notice";

const started = (request) => {
  return {
    type: types.DEMO_START,
    request: request
  };
};

const succeeded = (demo) => {
  return {
    type: types.DEMO_SUCCESS,
    demo: demo
  };
};

const failed = (error) => {
  return {
    type: types.DEMO_FAILURE,
    error: error && error.data && error.data.code ? error.data.code : "000"
  };
};

export const requestdemo = (body) => {
  return dispatch => {
    dispatch(started('demo'));
    axios.post("/apex/business/demo", body)
    .then(response => {
      dispatch(succeeded(response.data));
			dispatch(notifySuccess("demo", "primary"));
    })
    .catch(error => {
      dispatch(failed(error.response));
    });
  };
};